import ContactWrapper from "../components/ContactPage/ContactWrapper/ContactWrapper"
import Head from '../components/global/Head/Head'

const ContactPage = () => {
  <Head
        keyword={"Kontakt Reality Bulgaria,  agencja nieruchomości, WhatsApp: +48 518 160 166, info@realitybulgaria.pl, bezpłatne konsultacje, zakup nieruchomości"}
        title={
          "Kontakt | WhatsApp: +48 518 160 166 | info@realitybulgaria.p"
        }
        ogTitle={
          "Kontakt | WhatsApp: +48 518 160 166 | info@realitybulgaria.p"
        }
        description={
          "Skontaktuj się z naszą agencją Reality Bulgaria, aby uzyskać bezpłatną konsultację i profesjonalną pomoc w zakupie nieruchomości."
        }
        ogDescription={
          "Skontaktuj się z naszą agencją Reality Bulgaria, aby uzyskać bezpłatną konsultację i profesjonalną pomoc w zakupie nieruchomości."
        }
      />
  return <ContactWrapper/>;

  
  
};

export default ContactPage;
